import { render, staticRenderFns } from "./SetThermometer.vue?vue&type=template&id=b9457bc0&scoped=true"
import script from "./SetThermometer.vue?vue&type=script&lang=js"
export * from "./SetThermometer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9457bc0",
  null
  
)

export default component.exports